import React from 'react';
import { Outlet } from 'react-router-dom';
import HelmetWrapper from 'components/HelmetWrapper';

const BuyerRouter: React.FC = () => {
  return (
    <>
      <HelmetWrapper title="Buying portfolio" />
      <Outlet />
    </>
  );
};

export default BuyerRouter;
